// import { Image } from 'antd-mobile';
import './index.less'
// 图片
// import titlePng from './image/title.png'

const BillingRules = (props:any) => {
  return (
    <div className='billing-rules'>
      <p>当前车费参考出租车计费方式，往返车费归教练所得</p>
      {/* <Image src={titlePng} /> */}

      <ul>
        <li>
          <span>城市</span>
          <span>起步</span>
          <span>里程</span>
        </li>
        <li>
          <span>深圳市<br />广州市<br />北京市<br />上海市</span>
          <span>2公里内起步<br />起步10元</span>
          <span>2.7元/公里</span>
        </li>
        <li>
          <span>其它城市</span>
          <span>3公里内起步<br />起步8元</span>
          <span>1.9元/公里</span>
        </li>
      </ul>
    </div>
  )
}

export default BillingRules